import type { Entity } from '../../../core/models/entity.model';

export interface LoginEntityState {
  loginEntity: Entity;
  error: any;
  loginEntityLoading: boolean;
}

export const initialState: LoginEntityState = {
  loginEntity: null,
  error: null,
  loginEntityLoading: false
};
